<script lang="ts">
  import { onMount } from "svelte";
import { navigate } from "../../app.logic";
  import MainLayout from "../../layout/MainLayout.svelte"; 

  
</script>

<MainLayout>
  <h1>Report statici</h1>
    <div class="tile is-ancestor dashboard-tiles noselect">
      <div class="tile is-parent">
        <article
          on:click={() => navigate(`/reports/magazine`)}
          class="tile is-child box has-text-centered dashboard-box-leads is-clickable"
        >
          <p class="title is-size-1 dashboard-tile-text">
            Export Magazine
          </p>
          <p class="subtitle dashboard-tile-text">Esporta in excel lo stato di magazine di tutti i clienti, fornitori e lead</p>
        </article>
      </div>

      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-leads"
        >
          <p class="title is-size-1 dashboard-tile-text">
          </p>
          <p class="subtitle dashboard-tile-text"></p>
        </article>
      </div>

      <div class="tile is-parent">
        <article
          class="tile is-child box has-text-centered dashboard-box-leads"
        >
          <p class="title is-size-1 dashboard-tile-text">
            
          </p>
          <p class="subtitle dashboard-tile-text"></p>
        </article>
      </div>
          
    </div>

</MainLayout>

<style>
  .dashboard-tiles {
    margin-top: 1rem;
  }
  .dashboard-tile-text {
    color: #f8f8f8;
  }
  .dashboard-box-leads {
    background-color: #7799bd;
  }
  /*.dashboard-box-companies {
    background-color: #7799bd;
  }
  .dashboard-box-contacts {
    background-color: #7799bd;
  }
  .dashboard-box-deals {
    background-color: #7799bd;
  }*/
</style>
